import {Button, Stack, Typography, useTheme} from '@mui/material';
import {AlertInfo} from 'presentation/components/AlertInfo';
import {useContractStatus} from 'presentation/hooks';
import Icon from 'presentation/icons';
import IconNamesType from 'presentation/icons/IconNamesType';

import {translations} from 'presentation/translations-new';
import {formatMasks} from 'presentation/utils';
import React from 'react';
import {MyProfileEnum} from 'main/analytics/gaTagsEnum';
import {AlertEnum} from 'presentation/pages/private/profile/store/changeDataAlertStore/types';
import {CellPhoneDataProps} from './types';

const {
	contact: {changeCellphone, withoutCellPhone, invalidPhone},
	successAlert,
	errorAlert,
} = translations['pt-br'].privateFlow.profile.changeData;

const getSuccessMessage = (phone?: string) =>
	phone
		? `Seu novo número ${formatMasks('phone', phone)} foi salvo com sucesso. Usaremos ele para enviar avisos do seu plano.`
		: successAlert.account;

const CellPhoneData = ({data, onOpenForm, status, isPhoneInvalid}: CellPhoneDataProps) => {
	const {palette} = useTheme();

	const showAlert = status.status && status.type === AlertEnum.CELLPHONE;
	const {typeMessage} = status;
	const message = {
		success: getSuccessMessage(data.cellPhone),
		error: errorAlert,
	};

	const icon = {
		success: 'check-circle-outline-filled',
		error: 'error-outline',
	};

	const {isValid, isCancelledAtFiveYears} = useContractStatus();

	return (
		<Stack gap={2}>
			{showAlert ? (
				<AlertInfo.Root
					severity={typeMessage}
					icon={<Icon name={icon[typeMessage] as IconNamesType} />}>
					<Typography fontSize={'1rem'} fontWeight={600}>
						{message[typeMessage]}
					</Typography>
				</AlertInfo.Root>
			) : null}
			{isPhoneInvalid ? (
				<AlertInfo.Root severity="warning">
					<AlertInfo.Description>{invalidPhone}</AlertInfo.Description>
				</AlertInfo.Root>
			) : null}
			<Stack alignItems="center" gap={1} mt={showAlert ? 1 : 0} flexDirection="row">
				<Icon size={24} color={palette.primary.main} name="phone-android-filled" />
				<Typography color="text.primary">
					{data.cellPhone ? formatMasks('phone', data.cellPhone) : withoutCellPhone}
				</Typography>
			</Stack>
			<Stack direction="row" justifyContent="flex-end">
				{isValid || isCancelledAtFiveYears ? (
					<Button
						variant="text"
						onClick={onOpenForm}
						data-tag-id={MyProfileEnum.CLICK_ALTERAR_CELULAR}>
						{changeCellphone}
					</Button>
				) : null}
			</Stack>
		</Stack>
	);
};

export {CellPhoneData};
